import AppConstants from '../config/app.constants';

let UserService = function ($http, $q) {

    let profile = () => {
        return $http
            .post(AppConstants.api + `/user/profile`)
            .then((res) => {
                return res.data
            })
    };

    let acl = (userId, branchId) => {
        let query = ''
        if (userId) {
            query = `?user=${userId}&branchId=${branchId}`
        }
        return $http
            .get(AppConstants.api + `/acl/user-resources` + query)
            .then((res) => {
                return res.data
            })
    }
    let updateAcl = (obj, allow) => {
        let url = (allow) ? 'allow' : 'revoke'
        return $http
            .post(AppConstants.api + `/acl/${url}`, obj)
            .then((res) => {
                return res.data
            })
    }
    let role = (userId, branchId) => {
        let query = ''
        if (userId) {
            query = `?user=${userId}&branchId=${branchId}`
        }
        return $http
            .get(AppConstants.api + `/acl/user-roles` + query)
            .then((res) => {
                return res.data
            })

    }
    let addRole = (id, branchIds, role = '') => {
        let data = {
            role: ''
        }
        data['role'] = role.length > 0 ? role : `user:${id}`
        if (id > 0) { //if true : role will be allocated to current user
            data['user'] = id
        }
        if (branchIds) { //if true : role will be allocated to current user
            data['branchIds'] = branchIds
        }
        return $http
            .post(AppConstants.api + `/acl/add-roles-user`, data)
            .then((res) => {
                return res
            })
    }

    let createBranchGrouped = (data) => {
        return $http
            .post(AppConstants.api + `/user/grouped`, data)
            .then((res) => {
                return res.data
            })
    };

    let getUserBranchGroup = (userId) => {
        let query = '';
        if (userId) {
            query = `?user=${userId}`
        }
        return $http
            .get(AppConstants.api + `/user/getBranchGroup` + query)
            .then((res) => {
                return res.data
            })
    }

    let updateBranchGrouped = (data) => {
        return $http
            .post(AppConstants.api + `/user/updateBranchGroup`, data)
            .then((res) => {
                return res.data
            })
    };

    let updatePermissions = (data) => {
        return $http
            .post(AppConstants.api + `/acl/update-permissions`, data)
            .then((res) => {
                return res.data
            })
    };

    let getBranchCounters = (branchId) => {
        return $http
            .get(AppConstants.api + `/users/get-branch-counters/${branchId}`)
            .then((res) => {
                return res.data
            })
    };

    return {
        profile,
        acl,
        updateAcl,
        role,
        addRole,
        createBranchGrouped,
        getUserBranchGroup,
        updateBranchGrouped,
        updatePermissions,
        getBranchCounters
    };
};

UserService.$inject = ['$http', '$q']

export default UserService;



// WEBPACK FOOTER //
// ./client/app/services/user.service.js